import { Separator } from "@/dls/Separator";

import styles from "./Divider.module.scss";

interface Props {
  label?: string;
}

const Divider: React.FC<Props> = ({ label }) => {
  if (!label) {
    return <Separator />;
  }

  return (
    <div className={styles.divider}>
      <Separator />
      <span className={styles.label}>{label}</span>
      <Separator />
    </div>
  );
};

export { Divider };
